import { useIsCollectionView } from './useCanEditIssues.tsx';
import { useCanEditFields, type CanEditFieldsProps } from './useCanEditFields.tsx';

export const useCanCreateFields = (options?: CanEditFieldsProps): boolean => {
	const canEditFields = useCanEditFields(options);
	// TODO: isCollectionView is already checked inside useCanEditFields
	// consider optimizing the check into => !isCollectionView && hasAccess
	const [isCollectionView] = useIsCollectionView();
	return canEditFields && !isCollectionView;
};
